export default {
  add: 'Add',
  articles: 'Article | Articles',
  tabs: {
    films: 'Films',
    guides: 'Guides',
    materials: 'Materials',
    guides_short: 'Guides',
    library: 'The bookshelf',
    games: 'Games',
    articles: 'Articles',
    go_to_films_in_area: 'Go to the films about {area}',
  },
  grades: {
    'arskurs_1-3': 'Year 1-3',
    'arskurs_3-6': 'Year 3-6',
    'arskurs_4-6': 'Year 4-6',
    'arskurs_5-7': 'Year 5-7',
    'arskurs_7-9': 'Year 7-9',
    'arskurs_8-10': 'Year 8-10',
    gymnasiet: 'Gymnasiet',
  },
  home: 'Home',
  print: 'Print',
  show_more: 'Show more',
  label_readmore_less: 'Show less',
  showing: 'Showing',
  of: 'out of',
  done: 'done',
  with: 'with',
  book_titles: 'titles',
  to_top: 'To the top',
  button_show_all: 'Show all',
  button_log_out_user: 'Logout',
  button_reset: 'Reset',
  button_done: 'Done',
  button_all_categories: 'All categories',
  button_download: 'Download',
  button_print: 'Print',
  button_close: 'Close',
  button_cancel: 'Cancel',
  button_save: 'Save',
  button_human_narration: 'Human narration',
  button_skip_to_content: 'Skip to content',
  choose_language: 'Choose language',
  label_version_number: 'Version',
  show_explanations: 'Show explanations',
  share_to_classroom: 'Share to Classroom',
  share_to_teams: 'Share to Teams',
  remove_all_members: 'Remove all members',
  title_teams: 'Microsoft Teams',
  book_added_to_shelf: 'Book added to the bookshelf',
  book_no_access: 'You do not have access to this book',
  login: {
    message_welcome_to_service_manabua: 'Welcome to Manabua!',
    message_welcome_to_service_begreppa: 'Welcome to Begreppa!',
    button_log_in: 'Log in',
    message_service_description: '',
    login_error: 'Sorry, there has been an error processing your request.',
    login_processing: 'Login processing, please wait...',
    logged_in_as: 'logged in as',
  },
  no_access: {
    title: 'You do not have access to this service',
    text: 'To see your services, click here',
    button: 'Go back to Log in',
  },
  forbidden: {
    title: '403 Forbidden. Something went wrong, you might be missing permissions to access this page.',
    text: 'You do not seem to have access to this page',
    button: 'To the homepage',
  },
  introduction: {
    title: 'What do you want to watch today?',
    text: '',
  },
  search: {
    search: 'Search',
    all_grades: 'All grades',
    all_subjects: 'All subjects',
    search_result: 'Search result:',
    no_video_search_result: 'No films found.',
    no_guide_search_result: 'No guides found.',
    all_languages: 'All languages',
    filters: 'Search filters',
    filter_by_grade: 'Filter by grade',
    filter_by_subject: 'Filter by subject',
    filter_by_language: 'Filter by language',
  },
  subject: {
    latest_films: 'Latest films',
    explore_all: 'Explore all',
  },
  film: {
    noRelatedFilms: 'Nothing to see here.',
    noFilms: 'No films here, but we are working on it!',
    filmsInArea: 'Films within area',
    filmsInAreaNamed: 'Films within {area}',
    videoLoading: 'Loading video…',
    page_title: 'Film: {title} – {area} – {service}',
    sound: 'Sound',
    soundOn: 'Sound on',
    soundOff: 'Sound off',
    subtitles: 'Subtitles',
    skipIntro: 'Skip intro',
    skipIntros: 'Skip intros',
    off: 'Off',
    shareVideo: 'Share video',
    label_volume_slider: 'Adjust volume',
    label_playback_speed_slider: 'Adjust playback speed',
    label_subtitle_size_slider: 'Adjust subtitle size',
    label_seek_slider: 'Adjust playback position',
    copiedVideoLink: 'Video link copied to clipboard!',
    immerseInStudyMaterial: 'Textbooks',
    immerseLinksComingSoon: 'Immerse links coming soon.',
    keywordsComingSoon: 'Keywords will be added soon...',
    button_keyword_image: 'Click to show a larger image',
    keyword_image: 'Keyword image',
    missingFilms: 'Films missing',
    show_explanations: 'Show explanations',
    keywordsSwitchView: 'Flashcards',
    keywordsListView: 'Listview',
    easyToRead: 'Easy to read',
    subtitle: 'Subtitle',
    audioAndSubtitles: 'Audio and subtitles',
    label_list_audio_tracks: 'Audio tracks',
    label_list_subtitle_tracks: 'Subtitle tracks',
    play: 'Play',
    pause: 'Pause',
    rewind: 'Rewind 10 seconds',
    forward: 'Forward 10 seconds',
    play_all: 'Play all',
    subtitleSize: 'Subtitle size',
    share: 'Share',
    shareLink: 'Share link',
    playbackSpeed: 'Playback speed',
    fullscreen: 'Fullscreen',
    scrubber_minutes: 'minutes',
    scrubber_seconds: 'seconds',
    tabs: {
      concept: 'Keywords',
      quiz: 'Quiz',
      quiz_and_exercises: 'Quiz & Exercises',
      immerse: 'Textbooks',
      subtitles: 'Text',
      teaching: 'Teaching',
      curriculum: 'Curriculum',
      exercises: 'Exercises',
      articles: 'Articles',
      materials: 'Materials',
    },
    immerseTooltip: 'Links to study guides and textbook recordings.',
    articlesTooltip:
      'Articles related to the video. Your school has a license to the Trovy service, so just follow the link and log in to read the article. The links are suggested by AI.',
    noRelatedArticles: 'No related articles were found.',
    textbooks_explainer_teacher:
      'Want to learn more about this topic in your text book? Just click a book cover below, to get direct links to the most relevant sections. \n' +
      'If you see a stack of multiple books, it means that you also have a multi lingual text book audio guide available for that book.\n' +
      'These suggestions are generated using artificial intelligence. Please let us know if you see any strange suggestions, or if you miss anything!',
    textbooks_explainer_student:
      'Want to learn more about this topic in your text book? Just click a book cover below, to get direct links to the most relevant sections. \n' +
      'If you see a stack of multiple books, it means that you also have a multi lingual text book audio guide available for that book. \n' +
      'These suggestions are generated using artificial intelligence.',
    tooltip_share: 'Share video',
  },
  languages: {
    name: {
      'sv-SE': 'Svenska',
      'en-GB': 'English',
      'nb-NO': 'Bokmål',
      'nn-NO': 'Nynorsk',
      'fi-FI': 'Suomi',
    },
    sv: 'Swedish',
    de: 'German',
    en: 'English',
    'en-gb': 'English',
    ar: 'Arabic',
    es: 'Spanish',
    fa: 'Dari',
    fr: 'French',
    prs: 'Dari', // TODO: Should be able to use lokalise's key referencing feature to avoid duplicate keys but couldn't make it work
    fi: 'Finnish',
    'no-nb': 'Norwegian (Bokmål)',
    nb: 'Bokmål',
    nn: 'Nynorsk',
    'no-nn': 'Norwegian (Nynorsk)',
    pl: 'Polish',
    ru: 'Russian',
    so: 'Somali',
    th: 'Thai',
    ti: 'Tigrinya',
    uk: 'Ukrainian',
    ukr: 'Ukrainian',
    tk: 'Turkish',
    et: 'Estonian',
    sw: 'Swahili',
    ur: 'Urdu',
    ro: 'Romanian',
    hu: 'Hungarian',
    'pt-PT': 'Portugese',
    sr: 'Serbian',
    kmr: 'Kurmanji',
    bs: 'Bosnian',
    ku: 'Kurdish',
    ckb: 'Kurdish (Sorani)',
    hr: 'Croatian',
    sq: 'Albanian',
    it: 'Italian',
    lt: 'Lithuanian',
    ps: 'Pashto',
    vi: 'Vietnamese',
    mn: 'Mongolian',
    nl: 'Dutch',
    uz: 'Uzbek',
    zh: 'Chinese (Mandarin)',
  },
  quiz: {
    quiz_progress: 'Question {current}/{last}',
    final_result: '{correct}/{total} correct answers!',
    try_again: 'Try again!',
    congratulations: 'Congratulations - you got it!',
    congratulations_next_quiz: 'Congratulations! You can now take the next quiz.',
    congratulations_all_quizzes_completed:
      'Congratulations on completing the quizzing! You can redo them anytime if you like.',
    back: 'Back',
    next: 'Next',
    show_result: 'Show my results',
    loading_quiz: 'Loading quiz',
    correcting_answers: 'Grading...',
    repeat_first_quiz: 'Take previous quiz',
    repeat_quiz: 'Redo quiz',
    next_quiz: 'Take next quiz',
    replay_film: 'Watch film again',
    go_to_immerse: 'Go to textbooks',
    your_answer: 'Your response',
    correct_answer: 'Correct response',
    locked_quiz_explanation: 'Once you have completed the first quiz, you will be able to take the next quiz.',
    unlocking_a_quiz_requires_all_successful_answers:
      'You need all the correct answers to the first quiz to move on to the next quiz.',
    feedback: {
      0: ['Too bad!', 'Whoops!', 'Oh no!'],
      1: ['You can do better!', 'Try again!', 'Once again maybe?'],
      2: ['You can do better!', 'Try again!', 'Once again maybe?'],
      3: ['Almost there', 'Not quite there', 'Try again!'],
      4: ['Great work!', 'Wow!', 'Congratulations - you got it!'],
    },
    error_saving_submission: 'There was an error saving your answers.',
  },
  menu: {
    profile: 'Profile',
    dashboard: 'ILT Home',
    latest_news: 'Latest news',
    settings: 'Settings',
    support: 'Support',
    my_page: 'My page',
    manage_users: 'Manage users',
    feedback_form: 'Give us feedback!',
    teacher_guide: 'Guide',
    native_language_teacher: 'For native language teachers',
    account: 'Account',
    dark_mode: 'Dark mode',
    dark_mode_toggle: 'Dark mode toggle',
  },
  videos: {
    title: 'Videos',
    page_description:
      'Browse and search educational films by subject. Choose a subject to see its films, or use the search field to find a specific film.',
    page_title: 'Films – {service}',
    subject_page_title: '{subject} – {service}',
    secondary_school_programs: 'Upper secondary programmes',
    latest_added_articles: 'Latest added articles',
  },
  guides: {
    title: 'Audioguides to your textbooks',
    show_more_description:
      'Our audioguides assists you in understadning your textbooks in your mother tongue. The audioguides are available in Tigrinja, Arabic, Somali och Persian/Dari. Search for you textbook below,',
    show_more_link: 'or get an overview of our selection here.',
    introduction_paragraph:
      'A Learning Media Guide is an audio book that summarises a traditional textbook. Select language, subject or grade to see what guides are currently available, or search by book title. Then you can listen to the guide here on this page, or download the Inlästa Läromedel app to listen to the guides anytime, anywhere.',
    book_features: 'Book features',
  },
  library: {
    button_favourite: 'Favourite book',
    button_share: 'Share book',
    button_go_to_details: 'Go to book details',
    button_add_to_collection: 'Add to collection',
    button_play: 'Read book',
    buy: 'Buy',
    onCD: 'on CD',
    book_title: 'title',
    price: 'Price',
    organisation: 'Organisation',
    add_and_play_book: 'Add and play book',
    my_bookshelf: 'My bookshelf',
    add_book_to_student: "Add to student's bookshelf",
    author: 'Author',
    publisher: 'Publisher',
    related_content: 'Related content',
    playtime: 'Playtime',
    link_to_book: 'Link to the book',
    listen: 'Listen',
    student_bookshelf: 'Students bookshelf',
    no_access_to_book: 'This book is not available in your subscription',
    require_secure_login: 'Requires secure authentication',
    remove_from_shelf: 'Remove from bookshelf',
    book_removed_from_shelf: 'Book removed from bookshelf',
    buy_CD: 'Buy on CD',
    your_books_in_shelf: 'My books',
    epub_explanation: 'This is an ePub book. It contains both audio and text.',
    full_text: 'Full text',
    only_for_speaking_book_rights: 'This is book is only for users with speaking book rights',
    no_books_in_shelf: 'There are no books in your bookshelf!',
    no_books_found: "Couldn't find any books",
    sorting: {
      last_added: 'Last added',
      last_read: 'Last Read',
      title: 'Title',
      author: 'Author',
    },
    textbooks_in_swedish: 'Textbooks in Swedish',
    textbooks_in_other_languages: 'Textbooks in other languages',
    available_in_multiple_languages: 'Available in multiple languages',
  },
  my_page: {
    edit_info: 'Edit info',
    no_videos: 'Here you will find the films you have watched.',
    collections_tab: {
      tab_title: 'Collections',
      my_collections: 'My Collections',
      shared_with_me: 'Shared with me',
    },
    watched_films_tab: {
      tab_title: 'History',
    },
    progress_tab: {
      tab_title: 'Progress',
    },
    no_data: 'No data available',
    my_students_tab: {
      tab_title: 'My Students',
      page_title: 'Selected students',
      content_title: 'All students',
      search_placeholder: 'Name',
      student: 'Student | Students',
      group: 'Group | Groups',
      organization: 'Organization | Organizations',
    },
  },
  user_page: {
    no_videos: 'Here you will find the films the student has watched.',
    watched_films_tab: {
      tab_title: 'Watched films',
    },
  },
  flash_card: {
    click_to_flip: 'Click to flip the card',
    next_slide: 'Next slide',
    next_slide_short: 'Next',
    prev_slide: 'Previous slide',
    prev_slide_short: 'Previous',
    card: 'Card',
  },
  kahoot: {
    tooltip1: 'KAHOOT! is an external service.',
    tooltip2: 'We recommend using KAHOOT! without logging in, in guest mode, to avoid the disclosure of personal data.',
    tooltip3:
      'We do not share any personal data with KAHOOT! The KAHOOT! button is only shown to teachers using this service.',
    button_show_kahoot_tooltip: 'Show Kahoot info',
    button_go_to_kahoot: 'Go to Kahoot',
  },
  reflection_questions: {
    button_label: 'Reflection Questions',
    questions_for_prefix: 'Reflection questions for',
    questions_for_suffix: '',
    show_as_list: 'Show questions as a list',
    show_one_at_a_time: 'Show one question at a time',
  },
  find_out_more: {
    button_label: 'Find Out More',
    questions_for_prefix: 'Find out more about',
  },
  curriculum: {
    curriculum_title_1: 'The film covers parts of the following key content for ',
    curriculum_title_2: ':',
    grade_prefix: '',
  },
  games: {
    title: 'Games',
    word_of_the_day: {
      name: 'Word of the day',
      description: 'Learn new words every day',
    },
    match_the_pairs: {
      title: 'Matcha',
      name: 'Match the pairs',
      description: 'Practice the concepts with this exercise',
      start_game_condition: "There're should be at least 2 pairs to start a new game.",
      label_select_keyword: 'Select keyword',
      label_select_description: 'Select description',
      label_selected: 'Selected',
      label_click_to_select: 'Click to select',
      select_language: 'Select language',
      play_again: 'Play again',
      shuffle_new: 'Shuffle new',
      exit: 'Exit',
      feedback: {
        correct: 'Correct!',
        incorrect: 'Incorrect! Try again.',
        restart_game: 'New game started',
        game_finished: 'Congratulations! You finished the game!',
      },
    },
    the_human_body: {
      title: 'The human body',
      name: 'The human body',
      description: 'Learn about the human body with this exercise',
      start_text: 'Explore',
    },
    quizter: {
      title: 'Quizter',
      name: 'Quizter',
      description: 'Learn together by answering quiz questions',
    },
    escape_room: {
      title: 'Escape room',
      name: 'Escape room',
      description: 'This is the famous escape room',
    },
    planet_earth: {
      title: 'On the map',
      name: 'Planet earth',
      description: "Explore the world through Manabua's videos",
    },
    start_text: 'Start exercise',
    restart_text: 'Redo the exercise',
    finish_text: 'Finish the exercise',
  },
  page_not_found: {
    title: '404 Not Found',
    description: 'The page you are looking for does not exist!',
    action: 'To the homepage',
  },
  area_guide: {
    go_to: 'Get started',
    click_to_see: 'Click to see explanation',
    greppa: 'Get started with',
    label_navigation: 'Get started navigation',
    page_title: 'Explore {area} – {service}',
    go_to_area_guide: 'Go to the guide for {area}',
    show_supporting_language: 'Show supporting language',
    supporting_language_explainer: 'Select the supporting language you want to show',
    tooltip_show_supporting_language: 'Toggle on/off to show/hide supporting language',
    navigation: {
      item_1: 'Pre-understanding',
      item_1_1: 'What do I already know?',
      item_1_2: 'Think for a moment',
      item_1_3: 'Look at the pictures',
      item_2: 'Motivation',
      item_2_1: 'Why should I learn this?',
      item_2_2: 'Did you know that...',
      item_2_3: 'Reflect for a moment...',
      item_3: 'Movies',
      item_4: 'Keywords',
    },
    label_go_to_next_section: 'Go to next section',
    label_side_menu: 'Side menu',
    label_side_menu_sub_menu: 'Sub menu',
    label_go_back_to_keyword_nav: 'Go back to keyword list',
    carousel: {
      label_next: 'Navigate to next slide',
      label_prev: 'Navigate to previous slide',
      button_flip_image: 'Flip card',
    },
  },
  content_search: {
    search_button: 'Search',
    label_search_bar: 'Search',
    label_search_results: 'Search result',
    label_search_filters: 'Filters',
    label_remove_all_filters: 'Remove all filters',
    label_search_by_filters: 'Search by filters',
    no_data: 'We could not find any data',
    search: {
      sort: {
        none: 'Sort',
        lastAdded: 'Last added',
        titleDesc: 'Title A-Z',
        titleAsc: 'Title Z-A',
        authorDesc: 'Author A-Z',
        authorAsc: 'Author Z-A',
      },
    },
    label_number_input_min: 'Minimum',
    label_number_input_max: 'Maximum',
  },
  content_collections: {
    button_new_collection: 'Create new collection',
    button_order: 'Order items',
    button_order_done: 'Done',
    button_share: 'Share',
    title_share_dialog: 'Share collection',
    label_new_collection: 'New collection',
    label_collection_name: 'Collection name',
    label_choose_collection: 'Choose collection',
    label_edit_collection: 'Change collection',
    message_created: 'Collection created',
    message_added_to_collection: 'Added to {collection}',
    no_content_in_collection: 'There are no videos yet in this collection',
    no_collections: 'You have no collections yet',
    no_shared_collections: 'No collections have been shared with you yet',
    tooltip_add_to_collection: 'Add to collection',
    share_collection: 'Share collection',
    share_complete_message: 'Collection shared successfully',
    owners_error_message: 'At least one owner is required',
    label_share_collection: 'Share this collection',
    label_follow_collection: 'Follow collection',
    label_unfollow_collection: 'Unfollow collection',
    message_followed: 'You are now following this collection',
    message_unfollowed: 'You have unfollowed this collection',
    message_remove_from_owners: 'Are you sure you want to remove yourself as owner?',
    message_make_public_info: 'Make this collection public so others can find and subscribe to it',
  },
  components: {
    added: 'Added',
    add_button: 'Add',
    name: 'Name',
    user_name: 'User name',
    role: 'Role',
    roles: {
      student: 'Student',
      employee: 'Employee',
      guardian: 'Guardian',
      admin: 'Admin',
    },
    add_button_label: 'Add content',
    button_details: 'Collection details',
    button_done: 'Done',
    button_remove_collection: 'Remove collection',
    button_close: 'Close',
    cancel: 'Cancel',
    cancel_dialog: 'Are you sure you want to cancel?',
    yes: 'Yes',
    no: 'No',
    content: 'Content',
    select_item: 'Select item {name}',
    deselect_all: 'Deselect all',
    input_search: 'Search',
    label_description: 'Description',
    label_edit_description: 'Edit description',
    label_list_view: 'List',
    label_empty_description: 'Add description',
    label_edit_name: 'Edit name',
    label_add_members: 'Add members',
    label_add_owners: 'Add owners',
    label_additional: 'More',
    label_advanced_menu: 'More settings',
    label_filter_content_type: 'Filter by content type',
    label_settings_menu: 'Change collection settings',
    label_list: 'List of items',
    label_read_more: 'Show more',
    label_read_less: 'Show less',
    label_qr_code: 'QR code',
    loading_items: 'Loading items ...',
    loading_users: 'Loading users...',
    loading_groups: 'Loading groups...',
    label_sharing_options: 'Sharing options',
    label_google_classroom: 'Google classroom',
    label_microsoft_teams: 'Microsoft Teams',
    label_email: 'Email',
    label_copy_url: 'Copy URL',
    message_add_new_content: 'Add new',
    message_collection_deleted: 'Collection has been deleted',
    message_make_collection_public: 'Make this collection public so others can find and subscribe to it',
    no_data_available: 'No data available',
    of: 'of',
    organisation: 'Organization',
    owners: 'Owners',
    members: 'Members',
    users: 'Users',
    groups: 'Groups',
    processing: 'Processing',
    remove_button: 'Remove content',
    remove_member: 'Remove',
    search: 'Search',
    select: 'Manage',
    select_all: 'Select all',
    label_more_actions: 'More actions',
    sort: 'Sort',
    sort_done: 'Done',
    reorder_move_up: 'Move {title} up',
    reorder_move_down: 'Move {title} down',
    reorder_item_moved: 'Moved to position {position} of {total}',
    reorder_instructions: 'Press space to pick up an item, arrow keys to move it, space again to drop it.',
    reorder_item_grabbed: 'Picked up. Position {position} of {total}.',
    reorder_item_dropped: 'Dropped. Final position {position} of {total}.',
    reorder_item_pick_up: 'Pick up',
    reorder_item_put_down: 'Put down',
    reorder_place_instructions: 'Tap a row to place the item you picked up.',
    selected_contents: 'no item selected | one item selected | {count} item selected',
    selected_members: 'users selected',
    selected_groups: 'groups selected',
    share_collection_complete_message: 'Collection shared successfully',
    share_collection_owners_error_message: 'At least one owner is required',
    title: 'Title',
    collection_content: 'Videos',
    videos: 'Videos',
    items_per_page: 'Items per page:',
    next_page: 'Next page',
    prev_page: 'Previous page',
    last_page: 'Last page',
    unavailable_member: 'Unavailable member',
    unavailable_group: 'Unavailable group',
  },
  label_audience: 'Audience',
  label_category: 'Category',
  label_audience_alone: 'Alone',
  label_audience_pair: 'Pair',
  label_audience_group: 'Group',
  label_audience_class: 'Class',
  label_keywords: 'Categories', //These are not Manabua keywords, but Polylino named their tags/categories as keywords for Material
  label_no_matches: 'No matches',
  label_language: 'Language',
  label_status: 'Status',
  material_keywords: {
    lesson_plan: 'Lesson plan',
    poster: 'Poster',
    fill_in_the_blank: 'Fill-in-the-blank',
    worksheet: 'Worksheet',
    teacher_guides: 'Teacher guides',
    template: 'Template',
    checklist: 'Checklist',
    inspiration: 'Inspiration',
    reading_comprehension: 'Reading comprehension',
    book_circle: 'Book circle',
    vocabulary: 'Vocabulary',
    text_production: 'Text production',
    oral_presentation: 'Oral presentation',
    grammar: 'Grammar',
    concept_list: 'List of Concepts',
    exit_ticket: 'Exit Ticket',
  },
  material: {
    title: 'Materials',
    available_languages_tooltip: 'Available in multiple languages',
  },
  materials_landing_page: {
    quick_link_section_title: 'Material quick links',
    search_section_title: 'Search manually',
  },
  category_all_materials: 'All material',
  materials: {
    category_all_materials_description: 'Show all material',
    Djurpaket_description: 'PLACEHOLDER',
    Politik_description: 'PLACEHOLDER',
    Lektionstips_description: 'PLACEHOLDER',
    Affischer_description: 'PLACEHOLDER',
    Mallar_description: 'PLACEHOLDER',
    Människokroppen_description: 'PLACEHOLDER',
    Skrivuppgifter_description: 'PLACEHOLDER',
    Temaplaneringar_modersmål_description: 'PLACEHOLDER',
  },
  public_videos: {
    title: 'How the school works', // Så fungerar skolan
  },
  label_close: 'Close',
  label_main_navigation: 'Main navigation',
  label_breadcrumbs: 'Breadcrumbs',
  label_loading_books: 'Loading books',
  label_loading: 'Loading',
  label_processing: 'Processing',
  label_burger_menu_button: 'Burger menu',
  label_loading_search_results: 'Loading search results',
  label_go_back: 'Go back',
  label_subjects: 'Subjects',
  label_grades: 'Grades',
  label_areas: 'Areas',
  label_list_of_subjects: 'Subjects',
  label_languages_list: 'Languages',
  label_language_divider: 'Language divider',
  label_keywords_list: 'Keywords',
  tooltip_copy: 'Copy to clipboard',
  tooltip_copied: 'Copied!',
  last_updated: 'Last updated',
  created: 'Created',
  created_by: 'Created by',
  share: {
    message_remove_from_owners_will_delete_collection:
      'Since you are the only owner this will remove the collection, are you sure you want to remove the collection?',
    label_qr_code: 'QR code',
    label_google_classroom: 'Google classroom',
    label_microsoft_teams: 'Microsoft Teams',
    label_email: 'Email',
    label_sharing_options: 'Other sharing options',
    members: 'Members',
    owners: 'Owners',
    label_sharing_setting_off: 'Off',
    label_status_public: 'Public',
    label_status_private: 'Private',
  },
  show_button: {
    more: 'Show more',
    less: 'Show less',
  },
  buttons: {
    yes_delete: 'Yes, delete',
    no_cancel: 'No, cancel',
  },
  sr_only: {
    film_page: 'Film page:',
    reorder_instructions: 'Select an item by pressing spacebar, then press arrow keys to reorder.',
    reorder_item_grabbed:
      '{title}, grabbed. Current position in list: {position}. Press up and down arrows to change position, spacebar to drop.',
    reorder_item_moved: '{title}. New position in list: {position}',
    reorder_item_dropped: '{title}, dropped. Final position in list: {position}',
  },
  quizter: {
    back_to_video: 'Back to the video',
    back_to_games: 'Back to Games',
    start_game: 'Start',
    add: 'Add',
    add_video_clarification: 'Add Quizter from other videos',
    add_video_clarification_home_page: 'Click here to add videos',
    video_no_quiz_warning: 'Video "{title}" does not have a quiz and cannot be added.',
    generic_error: 'Something went wrong. Please try again.',
    subscribe: 'Save Quizter',
    unsubscribe: 'Remove Quizter',
    subscribe_success: 'Quizter saved to your shared Quizters.',
    unsubscribe_success: 'Quizter removed from your shared Quizters.',
    subscribe_error: 'Something went wrong. Please try again.',
    share_link_error: 'Could not create a share link. Please try again.',
    home: {
      my_quizters: 'My Quizters',
      shared_with_me: 'Shared with me',
      create_quizter: 'Create new Quizter',
    },
  },
  article_presenter: {
    show_more_from_publisher: 'Show more articles from',
  },
  ratings: {
    feedback_prompt: 'Did you enjoy the video?',
    thanks: 'Thanks for your feedback',
  },
} as const;
